import { render, staticRenderFns } from "./userFuka.vue?vue&type=template&id=22cd1504&scoped=true"
import script from "./userFuka.vue?vue&type=script&lang=js"
export * from "./userFuka.vue?vue&type=script&lang=js"
import style0 from "./userFuka.vue?vue&type=style&index=0&id=22cd1504&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cd1504",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22cd1504')) {
      api.createRecord('22cd1504', component.options)
    } else {
      api.reload('22cd1504', component.options)
    }
    module.hot.accept("./userFuka.vue?vue&type=template&id=22cd1504&scoped=true", function () {
      api.rerender('22cd1504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/userFuka.vue"
export default component.exports